import CrudRepository from './CrudRepository'
export default class CityCentersRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/city/center')
  }
}
